import React from 'react';
import { Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import {
    AdditionalInformationSectionModularProps,
    mapAdditionalInformationProps,
} from 'component/page/detail/MoreInfoSections/AdditionalInformation/AdditionalInformation.selectors';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesAdditionalInfoContainerSeenEventActivitiesFieldsV3 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesAdditionalInfoContainerSeenEventActivitiesManifestV3 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import Prerender from 'component/common/Prerender/Prerender';
import { useInView } from 'react-intersection-observer';
import AdditionalInfoLists from 'component/page/detail/MoreInfoSections/AdditionalInformation/AdditionalInfoLists';

const AdditionalInformationSectionModular: React.FC<AdditionalInformationSectionModularProps> = (props) => {
    const hasAdditionalInformation = props.additionalInformation && props.additionalInformation.length > 0;
    const hasPurchaseNotice = props.purchaseNotice.length > 0;
    const isShowAdditionalInformation = hasAdditionalInformation || hasPurchaseNotice;
    const { ref: AdditionalInformationRef, inView } = useInView({ triggerOnce: false, threshold: 1 });

    React.useEffect(() => {
        if (inView && isShowAdditionalInformation) {
            trackElementEvent<ActivitiesAdditionalInfoContainerSeenEventActivitiesFieldsV3>(ActivitiesAdditionalInfoContainerSeenEventActivitiesManifestV3.ids, {
                is_toggle_on: true,
            });
        }
    }, [inView, isShowAdditionalInformation]);

    if (!isShowAdditionalInformation) {
        return null;
    }

    return (
        <div ref={AdditionalInformationRef}>
            <Prerender.Hide>
                <Typography variant="body-s" textColor="base.subtle" tag="span" my="12">
                    {hasAdditionalInformation && <AdditionalInfoLists additionalInformation={props.additionalInformation} contentLocale={props.contentLocale} />}
                    {hasPurchaseNotice &&
                        props.purchaseNotice?.map((pn, index) => <AgodaMarkdown key={index} dataElementName="purchase-notice-description" input={pn.description || ''} />)}
                </Typography>
            </Prerender.Hide>
        </div>
    );
};
AdditionalInformationSectionModular.displayName = 'AdditionalInformationSectionModular';

export default connect(mapAdditionalInformationProps)(AdditionalInformationSectionModular);
